import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsDatepickerModule } from '@lcs/shared/datepicker';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { DateFilterComponent } from './date-filter.component';

@NgModule({
   declarations: [DateFilterComponent],
   exports: [DateFilterComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatNativeDateModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      MatOptionModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatFormFieldModule,
      LcsDatepickerModule,
      FormsModule,
      ReactiveFormsModule,
      MatNativeDateModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatSlideToggleModule,
   ],
})
export class DateFilterModule {}
